import React, { FC, Fragment } from 'react';
import { FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';

type GroupFilterDropdownProps = {
    groups: { _id: string; name: string }[];
    group: string;
    onGroupSelect: (category: string) => void;
};
const GroupFilterDropdown: FC<GroupFilterDropdownProps> = ({
    groups,
    group,
    onGroupSelect,
}: GroupFilterDropdownProps) => {
    const { t: translate } = useTranslation('lab-settings');

    return (
        <Fragment>
            <FormControl margin="dense" fullWidth style={{ minWidth: 150 }}>
                <InputLabel>{translate('lab-settings:GROUP')}</InputLabel>
                <Select
                    label={translate('lab-settings:GROUP')}
                    value={group}
                    onChange={(event: SelectChangeEvent<string>) => onGroupSelect(event.target.value)}
                    endAdornment={
                        <Fragment>
                            {group !== '' && (
                                <IconButton
                                    size="small"
                                    sx={{
                                        marginRight: '.75rem',
                                    }}
                                    onClick={() => onGroupSelect('')}
                                >
                                    <ClearIcon />
                                </IconButton>
                            )}
                        </Fragment>
                    }
                >
                    {groups?.map((group: { _id: string; name: string }) => (
                        <MenuItem key={group._id} value={group._id}>
                            {group.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Fragment>
    );
};

export default GroupFilterDropdown;
